import type { FC } from 'react';

import Content from './Content';
import Header from './Header';

import { StyledBodyText } from './Typography';

const GlobalErrorFallback: FC = () => (
	<>
		<Header />
		<Content>
			<StyledBodyText>An unknown error occurred.</StyledBodyText>
		</Content>
	</>
);

export default GlobalErrorFallback;
